/* ANYSNIFF tabs — replacement for Webflow's w-tabs runtime.
 * The buy page's colour switcher (Black / Blue / Grey) is a Webflow Tabs
 * component. Its CSS is already in the theme; only the behaviour needed
 * reimplementing. Contract is Webflow's own:
 *   .w-tab-menu  > .w-tab-link[data-w-tab]   -> gets .w--current
 *   .w-tab-content > .w-tab-pane[data-w-tab] -> gets .w--tab-active
 * Each .w-tabs instance is independent, so the desktop and mobile copies of the
 * switcher do not fight each other.
 */
(function () {
  'use strict';

  function activate(tabs, name) {
    tabs.querySelectorAll(':scope > .w-tab-menu > .w-tab-link').forEach(function (link) {
      var on = link.getAttribute('data-w-tab') === name;
      link.classList.toggle('w--current', on);
      link.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    tabs.querySelectorAll(':scope > .w-tab-content > .w-tab-pane').forEach(function (pane) {
      pane.classList.toggle('w--tab-active', pane.getAttribute('data-w-tab') === name);
    });
    // Let other code (e.g. a variant-aware price) react to the change.
    tabs.dispatchEvent(new CustomEvent('anysniff:tabchange', { detail: { tab: name }, bubbles: true }));
  }

  document.querySelectorAll('.w-tabs').forEach(function (tabs) {
    var links = tabs.querySelectorAll(':scope > .w-tab-menu > .w-tab-link');
    if (!links.length) return;

    links.forEach(function (link) {
      link.setAttribute('role', 'tab');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        activate(tabs, link.getAttribute('data-w-tab'));
      });
    });

    // Honour whatever Webflow marked as current in the markup.
    var current = tabs.querySelector(':scope > .w-tab-menu > .w-tab-link.w--current');
    activate(tabs, (current || links[0]).getAttribute('data-w-tab'));
  });
})();
